import { useUserInfo } from '@moniebook-web/utils';

import { MenusLoadingSkeleton } from './menus-skeleton/menus-skeleton';
import { Sidebar as AppSidebar } from './sidebar';
import { useAppSidebar } from './use-app-sidebar';

export function Sidebar() {
    const menuGroups = useAppSidebar();
    const { currentBusiness } = useUserInfo();

    if (!currentBusiness) return null;

    return (
        <>
            {menuGroups.length === 0 ? (
                <MenusLoadingSkeleton />
            ) : (
                <AppSidebar
                    menuGroups={menuGroups}
                    businessName={currentBusiness.name ?? ''}
                />
            )}
        </>
    );
}
